/* eslint-disable */
import jwtDecode from "jwt-decode";
import { clearHistoryReports } from "../../../reportng";

export function getToken() {
  return localStorage.getItem("token");
}

export function decodeToken() {
  const token = getToken();
  const decode: any = token ? jwtDecode(token) : null;
  if (decode) {
    decode["role"] = decode["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  }
  return decode as (null | { exp: number; sub: number; unique_name: string; family_name: string; email: string; role: string });
}

export function isAuth(): boolean {
  const decode = decodeToken();
  if (!decode) {
    return false;
  }
  const expDate = new Date(decode.exp * 1000);
  return Date.now() < expDate.getTime();
}

export function saveToken(token: string) {
  localStorage.setItem("token", token);
}

export function removeToken() {
  localStorage.removeItem("token");
  clearHistoryReports(); //TODO: Надо переработать архитектуру
}
